export default "__VITE_PUBLIC_ASSET__c99a2996__"